import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-[#EEF3E8] py-16 md:py-24" data-id="element-110">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white border border-[#D1E0C9] rounded-3xl p-8 md:p-16 text-center shadow-premium" data-id="element-112">
          <div className="flex justify-center mb-8" data-id="element-113">
            <div className="bg-[#EEF3E8] p-5 rounded-full border border-[#D1E0C9]" data-id="element-114">
              <ShieldCheckIcon className="w-12 h-12 text-[#5C8A6D]" strokeWidth={1.5} data-id="element-115" />
            </div>
          </div>

          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#3E2B1F] mb-6" data-id="element-116">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg md:text-xl text-[#3E2B1F]/80 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-117">
            Abrís los tomos. Probás las recetas. Aplicás las técnicas. Si en 7
            días no es lo que esperabas: devolución del 100% — sin formularios,
            sin drama, sin explicaciones.
            <br data-id="element-118" />
            <br data-id="element-119" />
            Confiamos en el producto. Por eso damos la garantía sin dudar.
          </p>

          <div className="inline-block bg-[#F7F2EA] border border-[#E7DDD2] px-6 py-3 rounded-full" data-id="element-120">
            <p className="text-lg font-bold text-[#B66A2C]" data-id="element-121">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}